import React from 'react';
import { Route } from 'react-router-dom';
import queryString from 'query-string';
// import { FlowDiagram } from './components';
import PrivateRoute from 'PrivateRoutes';
const FlowDiagram = React.lazy(() => import(/* webpackChunkName: "FlowDiagram" */'./components'));
const routes = () => [
  <PrivateRoute
    key="/settings/flowDiagram/:_id"
    exact
    path="/settings/flowDiagram/:_id"
    component={({ match, location }) => {
      const { typeFlowTable } = location.state || {};
      return <FlowDiagram integrationId={match.params._id} typeFlowTable={typeFlowTable} />;
    }}
  />
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Flow/routes.js